import { memo } from "react";
import classNames from "classnames";

import { TableCellValue, TableMetrics } from "../../types";
import VisibilityValue from "../ValueRenderers/VisibilityValue";
import NumberValue from "../ValueRenderers/NumberValue";
import NoData from "../NoData/NoData";

import styles from "./TableCell.module.css";

type TableCellContentProps = {
  columnId: string;
  value: TableCellValue | null;
  onOpenResponse: (responseId: string, metrics?: TableMetrics) => void;
};

const TableCellContent = memo(function TableCellContent({
  columnId,
  value,
  onOpenResponse,
}: TableCellContentProps) {
  const { value: metricValue, metrics, label, response, Icon, loader, metric } = value || {};
  const hasValue = metricValue !== undefined && metricValue !== null;
  const hasMetricsValue = Boolean(
    metrics &&
      (metrics.visibility !== undefined ||
        metrics.sentiment !== undefined ||
        metrics.ranking !== undefined),
  );
  const hasResponse = Boolean(response);
  const isNoData = !loader && !hasValue && !hasMetricsValue;
  const isTitleCell = Boolean(Icon) || columnId === "prompts";

  return (
    <div
      className={classNames(
        isTitleCell ? styles["table__cell-title"] : styles["table__cell-value"],
        !isTitleCell && isNoData && styles["is-no-data"],
        hasResponse && styles["is-response"],
      )}
    >
      {response && (
        <div
          className={classNames(styles["tooltip"], isNoData && styles["is-empty"])}
          onClick={() => onOpenResponse(response, metrics)}
        >
          View response
        </div>
      )}

      {isTitleCell ? (
        <>
          {Icon && <Icon />}
          {label}
        </>
      ) : metrics ? (
        isNoData ? (
          <NoData />
        ) : (
          <div className={styles["table__cell-metrics"]}>
            <VisibilityValue value={metrics.visibility} loader={loader} />
            <NumberValue value={metrics.sentiment} loader={loader} />
            <NumberValue value={metrics.ranking} loader={loader} />
          </div>
        )
      ) : metric === "visibility" ? (
        <VisibilityValue value={metricValue} loader={loader} />
      ) : (
        <NumberValue value={metricValue} loader={loader} />
      )}
    </div>
  );
});

export default TableCellContent;

